import React, { useState } from "react";
import { features } from "app/features";
import { _t } from "app/i18n/i18n";
import { preventDefault } from "lib/utils";
import { ListGroupItem } from "react-bootstrap";
import { Suggestion } from "./AutoCompleteSearchBox";

export const KeywordSuggestions = ({ keyword, setKeyword, onSubmit }) => {
  const [searchRadio, setSearchRadio] = useState("all fields");
  if (!features.autocompleteKeywordSuggestions || !keyword || !keyword.trim() || keyword.includes('"')) return null;

  const categoryName = searchRadio === "report title" ? "title" : "";
  const reportTitlesLabel = searchRadio === "report title" ? _t(" in report titles only") : "";

  const hasWordsLabel = (
    <>
      {_t("Has words: ")} <EM>{keyword}</EM> {reportTitlesLabel}
    </>
  );
  const exactPhraseLabel = (
    <>
      {_t("Exact phrase: ")} <EM>&quot;{keyword}&quot;</EM> {reportTitlesLabel}
    </>
  );
  const excludeWords = (
    <>
      {_t("Exclude words: ")} <EM>NOT &quot;{keyword}&quot;</EM> {reportTitlesLabel}
    </>
  );

  return (
    <>
      <ListGroupItem className="border-bottom  bg-white pl-0 pr-0">
        <h4 className="font-weight-light mb-0 pr-4">{_t("Search Options")}</h4>
        {AllFieldsTitleToggle(setSearchRadio, searchRadio)}
      </ListGroupItem>
      <Suggestion
        suggestion={{ CategoryName: categoryName, label: exactPhraseLabel, CategoryValue: `"${keyword}"` }}
        setKeyword={setKeyword}
        onSubmit={onSubmit}
      />
      <Suggestion
        suggestion={{ CategoryName: categoryName, label: hasWordsLabel, CategoryValue: keyword }}
        setKeyword={setKeyword}
        onSubmit={onSubmit}
      />
      <Suggestion
        suggestion={{ CategoryName: categoryName, label: excludeWords, CategoryValue: 'NOT "' + keyword + '"' }}
        setKeyword={setKeyword}
        onSubmit={onSubmit}
      />
    </>
  );
};

// preventDefault prevents blur event closing autocomplete on radio click
const AllFieldsTitleToggle = (setSearchRadio, searchRadio) => {
  const onChange = (ev) => setSearchRadio(ev.target.id);
  return (
    <section onMouseDown={preventDefault} className="mt-1">
      <label id="all fields" onClick={preventDefault} onMouseDown={onChange} className="mb-0">
        <input
          type="radio"
          id="all fields"
          name="toggle"
          checked={searchRadio === "all fields"}
          onChange={onChange}
          className="ml-2 mr-1 mb-0"
        />
        {_t("Search all fields")}
      </label>
      <label id="report title" onClick={preventDefault} onMouseDown={onChange} className="mb-0">
        <input
          type="radio"
          id="report title"
          name="toggle"
          checked={searchRadio === "report title"}
          onChange={onChange}
          className="ml-2 mr-1 mb-0"
        />
        {_t("Report titles only")}
      </label>
    </section>
  );
};

const EM = ({ children }) => <em className="text-info">{children}</em>;
